import { useContext, useState, useEffect, useRef } from "react";
import { GlobalContext } from "../../../Context/GlobalContext";
import usePosOrders from "../../../services/Pos/usePosOrders";
import DiscountModal from "./DiscountModal";
import CashPaymentModal from "./CashPaymentModal";
import { toast } from "react-toastify";
import UpiPaymentModal from "./UpiPaymentModal";
import SelectPaymentModal from "./OtherPaymentModal";
import useProfileDashboard from "../../../services/Settings/useProfileDashboard";
import AssignPackkyModal from "./AssignPackkyModal";
import useDining from "../../../services/Order/useDining";

export default function PaymentModal({
  cart,
  total,
  onClose,
  reciptDetails: parentReciptDetails,
  orderId,
  customerMobile,
  orderType,

  isPosTableSettlement = false,

  selectedTable,
  selectedRoom,
  onAfterOrderSuccess,
  isFullscreen,
  enterFullscreen,
  exitFullscreen,
  tabletMode,
  setTabletMode,
  setSelected,
  refreshCatalogueCache,
  loadingMenu,
  handleSyncTaxConfig,
  taxConfigLoading,
}) {
  const [reciptDetails, setreciptDetails] = useState({});
  const [printData, setPrintData] = useState(null);
  const [finalPaidAmount, setFinalPaidAmount] = useState(0);

  const finalReciptDetails =
    parentReciptDetails && Object.keys(parentReciptDetails).length > 0
      ? parentReciptDetails
      : reciptDetails;

  const normalizeOrderTypeForPayload = () => {
    const value = String(orderType || "")
      .toLowerCase()
      .trim();

    if (value === "dinein" || value === "dine-in" || value === "dining") {
      return "dining";
    }

    if (
      value === "homedelivery" ||
      value === "home delivery" ||
      value === "home_delivery"
    ) {
      return "home_delivery";
    }

    if (value === "takeway" || value === "take away" || value === "takeaway") {
      return "takeaway";
    }

    if (
      value === "room_order" ||
      value === "room order" ||
      value === "roomorder"
    ) {
      return "room_order";
    }

    return value;
  };

  const normalizedOrderType = normalizeOrderTypeForPayload();

  const getTableNo = () => {
    if (normalizedOrderType === "dining") {
      return (
        selectedTable?.tableNo ||
        selectedTable?.table_no ||
        selectedTable?.table ||
        selectedTable?.name ||
        ""
      );
    }

    if (normalizedOrderType === "room_order") {
      return (
        selectedRoom?.roomNumber ||
        selectedRoom?.roomNo ||
        selectedRoom?.room_no ||
        selectedTable?.roomNumber ||
        selectedTable?.roomNo ||
        selectedTable?.room_no ||
        selectedTable?.tableNo ||
        selectedTable?.table_no ||
        ""
      );
    }

    return "";
  };

  const normalizeOrderType = () => normalizedOrderType;

  const isRoomOrder = normalizedOrderType === "room_order";

  const {
    placePosOrder,
    getDiscountList,
    selectDiscountPosOrder,
    removeDiscountPosOrder,
    generatePaymentIntent,
    getPaymentStatus,
    generateOrderID,
    processPrintOrder,
    getOrderDetails,
    getOrders,
    assignDeliveryPartner,
    getOrganizationTaxConfig,
  } = usePosOrders();

  const { refreshDiningCache } = useDining();

  const { fetchReceiptDetails } = useProfileDashboard();

  const [tendered, setTendered] = useState("");
  const [tenderedTouched, setTenderedTouched] = useState(false);
  const [selectedMethod, setSelectedMethod] = useState("");
  const [showDiscountModal, setShowDiscountModal] = useState(false);
  const [showDiscountRemovedModal, setShowDiscountRemovedModal] =
    useState(false);
  const [showOrderPlaced, setShowOrderPlaced] = useState(false);
  const [showUPI, setShowUPI] = useState(false);
  const [showOtherPayment, setShowOtherPayment] = useState(false);
  const [deliveryChargesDeductedFrom, setDeliveryChargesDeductedFrom] =
    useState("customer");
  const [deliveryPartner, setDeliveryPartner] = useState("");
  const { userID } = useContext(GlobalContext);
  const [discount, setDiscount] = useState(0);
  const [appliedDiscountId, setAppliedDiscountId] = useState("");
  const [applyingDiscount, setApplyingDiscount] = useState(false);
  const [removingDiscount, setRemovingDiscount] = useState(false);
  const [orderData, setOrderData] = useState(null);
  const getOrgTaxStorageKey = (userid) => `pos_org_tax_config_${userid}`;

  const refreshTableRoomStatus = async () => {
    if (
      normalizedOrderType !== "dining" &&
      normalizedOrderType !== "room_order"
    ) {
      return;
    }

    try {
      const freshData = await refreshDiningCache();

      console.log("Fresh dining status:", freshData);

      return freshData;
    } catch (error) {
      console.error("Table/room status refresh error:", error);

      return {
        tables: [],
        rooms: [],
      };
    }
  };

  const getDiscountId = (discount) => {
    return (
      discount?.discountId ||
      discount?.id ||
      discount?.pk_discount_id ||
      discount?.discount_id ||
      ""
    );
  };

  const handleApplyDiscount = async (selectedDiscount) => {
    const finalOrderId = await getOrCreateOrderId();

    if (!finalOrderId) {
      toast.error("Order ID missing");
      return false;
    }

    const discountId = getDiscountId(selectedDiscount);

    if (!discountId) {
      toast.error("Discount ID missing");
      return false;
    }

    setApplyingDiscount(true);

    try {
      const res = await selectDiscountPosOrder({
        orderId: finalOrderId,
        discountId,
      });

      if (!res) {
        return false;
      }

      const amount = Number(selectedDiscount?.discountAmount || 0);

      setDiscount(amount);
      setAppliedDiscountId(discountId);

      const details = await getOrderDetails(finalOrderId);
      const finalOrder = Array.isArray(details) ? details[0] : details;

      if (finalOrder) {
        setOrderData(finalOrder);
      }

      // toast.success(`Discount applied: ₹${amount.toFixed(2)}`);
      return true;
    } catch (error) {
      console.error("Apply discount error:", error);
      toast.error("Unable to apply discount");
      return false;
    } finally {
      setApplyingDiscount(false);
    }
  };

  useEffect(() => {
    const loadPaymentPageData = async () => {
      if (!orderId) return;

      try {
        // Only get order details here
        const details = await getOrderDetails(orderId);

        const finalOrder = Array.isArray(details) ? details[0] : details;

        setOrderData(finalOrder || null);
      } catch (err) {
        console.error("Payment page data load failed:", err);
      }
    };

    loadPaymentPageData();
  }, [orderId]);

  useEffect(() => {
    const getReceipt = async () => {
      try {
        const res = await fetchReceiptDetails();

        const details = Array.isArray(res?.response)
          ? res.response[0]
          : Array.isArray(res)
            ? res[0]
            : res?.response || res || {};

        if (res?.responseCode === "00" && details) {
          const mappedReceipt = {
            business_name:
              details?.business_name ||
              details?.businessName ||
              details?.organization_name ||
              details?.restaurant_name ||
              "Restaurant",

            address:
              details?.address ||
              details?.restaurant_address ||
              details?.organization_address ||
              details?.business_address ||
              details?.shop_address ||
              details?.full_address ||
              "",

            phone_no:
              details?.phone_no ||
              details?.phoneNo ||
              details?.phone ||
              details?.mobile ||
              details?.mobile_no ||
              details?.contact_number ||
              details?.contact_no ||
              "",

            gst:
              details?.gst ||
              details?.gst_no ||
              details?.gstNo ||
              details?.gst_number ||
              "",

            fssaiNo:
              details?.fssaiNo || details?.fssai_no || details?.fssai || "",

            taxCgst:
              details?.taxCgst || details?.tax_cgst || details?.cgstRate || "0",

            taxSgst:
              details?.taxSgst || details?.tax_sgst || details?.sgstRate || "0",

            taxGst:
              details?.taxGst || details?.tax_gst || details?.gstRate || "0",

            tag_line1: details?.tag_line1 || details?.tagLine1 || "Visit Again",
          };

          sessionStorage.setItem(
            "pos_latest_receipt_details",
            JSON.stringify(mappedReceipt),
          );
          setreciptDetails(mappedReceipt);
        }
      } catch (err) {
        console.error("Receipt API error", err);
      }
    };

    getReceipt();
  }, []);

  const tenderedNum = parseFloat(tendered) || 0;
  const [showPackkyModal, setShowPackkyModal] = useState(false);
  const [deliveryCharge, setDeliveryCharge] = useState(0);

  const [payments, setPayments] = useState([]);
  const [discountList, setDiscountList] = useState([]);
  const [activeOrderId, setActiveOrderId] = useState(orderId || "");
  const [showSettleConfirm, setShowSettleConfirm] = useState(false);

  const [pendingSettlement, setPendingSettlement] = useState(null);

  const [settlingAmount, setSettlingAmount] = useState(false);
  const [paymentActionLoading, setPaymentActionLoading] = useState(false);

  // UI button lock
  const paymentActionLockRef = useRef(false);

  // Actual place-order API lock
  const placeOrderApiLockRef = useRef(false);
  const cashClickLockRef = useRef(false);

  useEffect(() => {
    cashClickLockRef.current = false;
    paymentActionLockRef.current = false;
    placeOrderApiLockRef.current = false;

    setPaymentActionLoading(false);
    setSelectedMethod("");
  }, [orderId]);

  const totalPaid = payments.reduce((sum, p) => sum + p.amount, 0);

  const toNum = (value) => {
    const n = Number(value);
    return Number.isFinite(n) ? n : 0;
  };

  const safeJsonParse = (value) => {
    if (!value) return value;

    if (typeof value !== "string") return value;

    try {
      const parsed = JSON.parse(value);

      // handles double-stringified JSON
      if (typeof parsed === "string") {
        try {
          return JSON.parse(parsed);
        } catch {
          return parsed;
        }
      }

      return parsed;
    } catch {
      return value;
    }
  };

  const parseCustomizations = (item) => {
    const raw =
      item?.customizations ||
      item?.customization ||
      item?.customizationData ||
      item?.customization_details ||
      item?.customize ||
      [];

    const parsed = safeJsonParse(raw);

    if (Array.isArray(parsed)) return parsed;

    if (parsed && typeof parsed === "object") return [parsed];

    return [];
  };

  const getCustomizationText = (item) => {
    return parseCustomizations(item)
      .flatMap((c) => {
        const options =
          c?.options ||
          c?.option ||
          c?.addons ||
          c?.values ||
          c?.value ||
          c?.selectedOptions ||
          [];

        if (Array.isArray(options)) return options;

        if (typeof options === "string") {
          const parsed = safeJsonParse(options);
          return Array.isArray(parsed) ? parsed : [options];
        }

        return [];
      })
      .filter(Boolean)
      .join(", ");
  };

  const sourceItems =
    Array.isArray(orderData?.items) && orderData.items.length > 0
      ? orderData.items
      : cart;

  const normalizedCart = sourceItems.map((item) => {
    const parsedCustomizations = parseCustomizations(item);

    return {
      ...item,

      qty: Number(item.qty || item.quantity || 1),
      price: Number(
        item.price ||
          item.item_price ||
          item.itemPrice ||
          item.selectedPrice?.price ||
          0,
      ),

      item_name:
        item.item_name || item.productName || item.actualName || "Item",

      customizations: parsedCustomizations,
      customization: JSON.stringify(parsedCustomizations),
    };
  });

  const normalizeDiscountList = (res) => {
    if (Array.isArray(res)) return res;
    if (Array.isArray(res?.response)) return res.response;
    return [];
  };

  const getStoredTaxConfig = () => {
    try {
      const raw = sessionStorage.getItem(getOrgTaxStorageKey(userID));
      return raw ? JSON.parse(raw) : {};
    } catch (error) {
      console.error("Tax config parse error:", error);
      return {};
    }
  };

  const storedTaxConfig = getStoredTaxConfig();

  // =========================================================
  // AMOUNT / GST LOGIC
  // Same payment calculation in both PaymentModal files.
  // Priority for subtotal:
  // 1. subtotal passed by DineScreen/current cart
  // 2. API subtotal
  // 3. normalized UI cart subtotal
  // =========================================================

  const uiCartSubtotal = normalizedCart.reduce((sum, item) => {
    const quantity = toNum(item?.qty || item?.quantity || 1);

    const unitPrice = toNum(
      item?.price ||
        item?.item_price ||
        item?.itemPrice ||
        item?.selectedPrice?.price ||
        0,
    );

    return sum + unitPrice * quantity;
  }, 0);

  const apiSubtotal = toNum(
    orderData?.subtotal ||
      orderData?.subTotal ||
      orderData?.subtotal_amount ||
      orderData?.subtotalAmount,
  );

  const passedSubtotal = toNum(total);

  const subtotal =
    passedSubtotal > 0
      ? passedSubtotal
      : apiSubtotal > 0
        ? apiSubtotal
        : uiCartSubtotal;

  const discountAmount =
    discount > 0
      ? toNum(discount)
      : toNum(
          orderData?.discount_amount ||
            orderData?.discountAmount ||
            orderData?.discount,
        );

  const taxableAmount = Math.max(subtotal - discountAmount, 0);

  const storedTotalTaxRate = toNum(
    storedTaxConfig?.totalTaxRate ||
      storedTaxConfig?.tax_gst ||
      storedTaxConfig?.taxGst ||
      0,
  );

  const cgstRate =
    toNum(
      storedTaxConfig?.cgstRate ||
        storedTaxConfig?.tax_cgst ||
        storedTaxConfig?.taxCgst ||
        reciptDetails?.taxCgst ||
        0,
    ) || (storedTotalTaxRate > 0 ? storedTotalTaxRate / 2 : 2.5);

  const sgstRate =
    toNum(
      storedTaxConfig?.sgstRate ||
        storedTaxConfig?.tax_sgst ||
        storedTaxConfig?.taxSgst ||
        reciptDetails?.taxSgst ||
        0,
    ) || (storedTotalTaxRate > 0 ? storedTotalTaxRate / 2 : 2.5);

  const totalTaxRate =
    storedTotalTaxRate > 0 ? storedTotalTaxRate : cgstRate + sgstRate;

  const gstType =
    storedTaxConfig?.gst_type ||
    storedTaxConfig?.gstType ||
    orderData?.gst_type ||
    orderData?.gstType ||
    reciptDetails?.gst_type ||
    reciptDetails?.gstType ||
    "excl";

  const normalizedGstType = String(gstType || "")
    .toLowerCase()
    .trim();

  const isInclusiveGst =
    normalizedGstType === "incl" || normalizedGstType === "inclusive";

  // GST rule:
  // - inclusive: extract GST from taxableAmount for display only.
  // - exclusive: calculate GST on taxableAmount and add it to grand total.
  // Keep this aligned with CashPaymentModal so payment and receipt match.
  const getTaxAmounts = (amount) => {
    const safeAmount = Math.max(toNum(amount), 0);
    const combinedSplitRate = cgstRate + sgstRate;

    if (isInclusiveGst) {
      const includedTotalTax =
        totalTaxRate > 0
          ? safeAmount - safeAmount / (1 + totalTaxRate / 100)
          : 0;

      if (combinedSplitRate > 0) {
        return {
          cgst: includedTotalTax * (cgstRate / combinedSplitRate),
          sgst: includedTotalTax * (sgstRate / combinedSplitRate),
        };
      }

      return {
        cgst: includedTotalTax / 2,
        sgst: includedTotalTax / 2,
      };
    }

    return {
      cgst: (safeAmount * cgstRate) / 100,
      sgst: (safeAmount * sgstRate) / 100,
    };
  };

  const taxAmounts = getTaxAmounts(taxableAmount);
  const cgstAmount = taxAmounts.cgst;
  const sgstAmount = taxAmounts.sgst;

  const hasLiveDiscount = discount > 0;

  const deliveryCharges =
    toNum(deliveryCharge) ||
    toNum(orderData?.deliveryAmount) ||
    toNum(orderData?.delivery_amount) ||
    toNum(orderData?.delivery_fee) ||
    toNum(orderData?.deliveryCharges) ||
    0;

  const calculatedGrandTotal = isInclusiveGst
    ? taxableAmount + deliveryCharges
    : taxableAmount + cgstAmount + sgstAmount + deliveryCharges;

  // Keep exact 2 decimal amount. Do not ceil/round to whole rupee.
  const grandTotal = Number(calculatedGrandTotal.toFixed(2));

  const apiDueAmount = toNum(
    orderData?.due_amount ||
      orderData?.dueAmount ||
      orderData?.remaining_amount ||
      orderData?.balance_amount,
  );

  // New/current payment uses calculated total.
  // Existing table/room partial settlement can use API due amount.
  const payableAmount =
    isPosTableSettlement && apiDueAmount > 0 ? apiDueAmount : grandTotal;

  const hasLiveDeliveryCharge = toNum(deliveryCharge) > 0;

  const change = Math.max(tenderedNum - payableAmount, 0);
  const remaining = Math.max(payableAmount - totalPaid, 0);

  const handleNumpad = (val) => {
    setTenderedTouched(true);

    if (val === "Clear") {
      setTendered("");
      return;
    }

    if (val === "EXACT") {
      setTendered(String(payableAmount));
      return;
    }

    setTendered((prev) => {
      const currentValue = String(prev || "");

      if (val === "." && currentValue.includes(".")) return currentValue;

      // If auto amount is showing, first number press should replace it
      if (!tenderedTouched && currentValue === String(payableAmount)) {
        return String(val);
      }

      return currentValue + String(val);
    });
  };

  const numpadKeys = [
    ["1", "7", "8", "9"],
    ["2", "4", "5", "6"],
    ["5", "1", "2", "3"],
    ["10", "0", "00", "."],
    ["20", "50", "100", "Clear"],
  ];

  const normalizedOrderTypeForUI = String(orderType || "")
    .toLowerCase()
    .trim()
    .replace(/\s+/g, "_");

  const isHomeDeliveryOrder = [
    "homedelivery",
    "home_delivery",
    "home_delivery_order",
    "home_deliveryorder",
  ].includes(normalizedOrderTypeForUI);

  const getOrCreateOrderId = async () => {
    if (activeOrderId) return activeOrderId;

    if (orderId) {
      setActiveOrderId(orderId);
      return orderId;
    }

    const generatedId = await generateOrderID({
      mobile: customerMobile || "9999999999",
      orderType: normalizeOrderType(),
    });

    if (!generatedId) {
      toast.error("Order ID generation failed");
      return "";
    }

    setActiveOrderId(generatedId);
    return generatedId;
  };

  const callPlacePosOrderOnce = async (payload) => {
    if (placeOrderApiLockRef.current) {
      console.warn("Duplicate placePosOrder API call blocked");

      return {
        responseCode: "DUPLICATE_BLOCKED",
        responseMessage: "Payment is already processing",
        duplicateBlocked: true,
      };
    }

    // Same millisecond me synchronous lock
    paymentActionLockRef.current = true;

    setPaymentActionLoading(true);

    try {
      const response = await placePosOrder(payload);

      if (response?.responseCode !== "00") {
        placeOrderApiLockRef.current = false;
        paymentActionLockRef.current = false;

        setPaymentActionLoading(false);
      }

      return response;
    } catch (error) {
      placeOrderApiLockRef.current = false;
      paymentActionLockRef.current = false;

      setPaymentActionLoading(false);

      throw error;
    }
  };

  const handlePlaceOrder = async (finalPayments = []) => {
    console.count("HANDLE PLACE ORDER START");

    console.log("handlePlaceOrder lock values:", {
      paymentActionLocked: paymentActionLockRef.current,
      placeOrderApiLocked: placeOrderApiLockRef.current,
      finalPayments,
    });

    if (placeOrderApiLockRef.current) {
      console.warn("Duplicate CASH payment blocked");

      return false;
    }

    placeOrderApiLockRef.current = true;
    paymentActionLockRef.current = true;

    setPaymentActionLoading(true);

    let orderPlacedSuccessfully = false;

    try {
      const normalizedType = normalizeOrderType();

      const finalOrderId = await getOrCreateOrderId();

      if (!finalOrderId) {
        toast.error("Order ID missing");

        return false;
      }

      const totalAmount = finalPayments.reduce(
        (sum, payment) => sum + Number(payment?.amount || 0),
        0,
      );

      const actualReceivedAmount = Number(
        totalAmount || tenderedNum || payableAmount,
      );

      if (!Number.isFinite(actualReceivedAmount) || actualReceivedAmount <= 0) {
        toast.error("Please enter valid payment amount");

        return false;
      }

      setFinalPaidAmount(actualReceivedAmount);

      const rawMobile =
        typeof customerMobile === "object"
          ? customerMobile?.mobile
          : customerMobile;

      const cleanMobile = String(rawMobile || "9999999999").replace(/\D/g, "");

      const finalMobile =
        cleanMobile.length === 10 ? `91${cleanMobile}` : cleanMobile;

      const finalDeliveryAmount = Number(deliveryCharges || 0);

      const finalDeliveryDeductedFrom =
        finalDeliveryAmount > 0
          ? deliveryChargesDeductedFrom || "customer"
          : "restaurant";

      const finalDeliveryPartner =
        finalDeliveryAmount > 0 ? deliveryPartner || "packky" : "";

      const isCurrentPaymentPartial =
        actualReceivedAmount > 0 &&
        actualReceivedAmount < Number(payableAmount);

      // Keep the existing table/room settlement behaviour, and also mark
      // a brand-new underpayment as Partial so the API does not treat it as paid.
      const finalPaymentType =
        isPosTableSettlement || isCurrentPaymentPartial ? "Partial" : "";

      const finalOrderStatus = isCurrentPaymentPartial ? "hold" : "completed";

      const payload = {
        userid: userID,
        currency: "INR",

        custMobile: finalMobile,
        custName: "",

        orderId: finalOrderId,
        orderType: normalizedType,
        orderStatus: finalOrderStatus,

        paymentMode: String(finalPayments[0]?.mode || "cash").toLowerCase(),

        paymentType: finalPaymentType,

        receivedAmount: Number(actualReceivedAmount).toFixed(2),

        tableNo: getTableNo(),

        roomNumber: normalizedType === "room_order" ? getTableNo() : "",

        deliveryAmount: String(finalDeliveryAmount),

        deliveryChargesDeductedFrom: finalDeliveryDeductedFrom,

        deliveryPartner: finalDeliveryPartner,

        items: normalizedCart.map((item) => {
          const quantity = Number(item?.qty || item?.quantity || 1);

          const price = Number(
            item?.price || item?.item_price || item?.selectedPrice?.price || 0,
          );

          return {
            productId: String(item?.item_id || ""),

            sizeId: String(
              item?.selectedPrice?.size_id ||
                item?.size_id ||
                item?.item_id ||
                "",
            ),

            productName: item?.item_name || item?.productName || "Item",

            actualName: item?.item_name || item?.productName || "Item",

            sizeWords:
              item?.selectedPrice?.size || item?.size || item?.sizeWords || "",

            quantity: String(quantity),

            itemPrice: String(price),

            itemImage: item?.image || item?.photo || item?.itemImage || "",

            customization: JSON.stringify(item?.customizations || []),

            hasVarient: item?.selectedPrice?.size_id ? "true" : "false",
          };
        }),
      };

      const res = await placePosOrder(payload);

      if (res?.responseCode !== "00") {
        toast.error(res?.responseMessage || "Order settle failed");

        return false;
      }

      orderPlacedSuccessfully = true;

      if (finalDeliveryAmount > 0) {
        sessionStorage.setItem(
          `pos_delivery_charge_${finalOrderId}`,
          JSON.stringify({
            orderId: finalOrderId,

            deliveryAmount: finalDeliveryAmount,

            deliveryChargesDeductedFrom: finalDeliveryDeductedFrom,

            deliveryPartner: finalDeliveryPartner,
          }),
        );
      }

      const placedOrderData = Array.isArray(res?.response)
        ? res.response[0]
        : res?.response || {
            orderid: finalOrderId,

            orderId: finalOrderId,

            orderType: normalizedType,

            table_no: getTableNo(),

            tableNo: getTableNo(),

            roomNumber: normalizedType === "room_order" ? getTableNo() : "",
          };

      // Calculate the remaining amount from the amount that was actually due
      // on this payment screen. This is reliable for both a new payment and an
      // existing partial settlement.
      const remainingAfterPayment = Number(
        Math.max(Number(payableAmount) - actualReceivedAmount, 0).toFixed(2),
      );

      const finalUiPaymentStatus =
        remainingAfterPayment > 0 ? "partially_paid" : "paid";

      const finalPrintData = {
        ...(placedOrderData || {}),
        ui_paid_amount: actualReceivedAmount,
        ui_due_amount: remainingAfterPayment,
        ui_payment_status: finalUiPaymentStatus,
      };

      setPrintData(finalPrintData);

      setOrderData({
        ...(placedOrderData || {}),
        due_amount: remainingAfterPayment,
        payment_status: finalUiPaymentStatus,
      });

      setShowOrderPlaced(true);

      try {
        await processPrintOrder(finalOrderId);
      } catch (printError) {
        console.error("Print failed:", printError);
      }

      // Refresh table/room status only once after the complete order flow.
      // Removed the immediate + delayed duplicate refresh calls.
      await refreshTableRoomStatus();

      return true;
    } catch (error) {
      console.error("Place order failed:", error);

      toast.error(error?.message || "Order settle failed");

      return false;
    } finally {
      if (!orderPlacedSuccessfully) {
        placeOrderApiLockRef.current = false;

        paymentActionLockRef.current = false;

        setPaymentActionLoading(false);

        setSelectedMethod("");
      }
    }
  };

  useEffect(() => {
    if (!tenderedTouched) {
      setTendered(String(payableAmount));
    }
  }, [payableAmount, tenderedTouched]);

  const handleRemoveDiscount = async () => {
    const finalOrderId = await getOrCreateOrderId();

    if (!finalOrderId) {
      toast.error("Order ID missing");
      return false;
    }

    if (!appliedDiscountId) {
      toast.error("No discount applied");
      return false;
    }

    setRemovingDiscount(true);

    try {
      const res = await removeDiscountPosOrder({
        orderId: finalOrderId,
        discountId: appliedDiscountId,
      });

      if (!res) {
        return false;
      }

      setDiscount(0);
      setAppliedDiscountId("");

      const details = await getOrderDetails(finalOrderId);
      const finalOrder = Array.isArray(details) ? details[0] : details;

      if (finalOrder) {
        setOrderData(finalOrder);
      }

      return true;
    } catch (error) {
      console.error("Remove discount error:", error);
      toast.error("Unable to remove discount");
      return false;
    } finally {
      setRemovingDiscount(false);
    }
  };

  const handleBackClick = () => {
    if (!appliedDiscountId) {
      onClose();
      return;
    }

    const finalOrderId = activeOrderId || orderId;

    if (!finalOrderId) {
      onClose();
      return;
    }

    const discountIdToRemove = appliedDiscountId;

    // UI immediately update
    setDiscount(0);
    setAppliedDiscountId("");
    setShowDiscountRemovedModal(true);

    // Screen should not wait for API
    setTimeout(() => {
      setShowDiscountRemovedModal(false);
      onClose();
    }, 500);

    // API call in background
    removeDiscountPosOrder({
      orderId: finalOrderId,
      discountId: discountIdToRemove,
    })
      .then((res) => {
        if (!res) {
          console.error("Discount remove failed in background");
        }
      })
      .catch((error) => {
        console.error("Background remove discount error:", error);
      });
  };

  const openDiscount = async () => {
    try {
      const finalOrderId = await getOrCreateOrderId();

      if (!finalOrderId) {
        toast.error("Order ID missing");
        return;
      }

      const res = await getDiscountList({
        amount: Number(subtotal || 0),
        orderId: finalOrderId,
      });

      const list = normalizeDiscountList(res);

      if (!list.length) {
        setDiscountList([]);
        toast.info("No discount available for this order");
        return;
      }

      setDiscountList(list);
      setShowDiscountModal(true);
    } catch (error) {
      console.error("Discount fetch error:", error);
      toast.error("Unable to fetch discounts");
    }
  };

  //   const connectMachine = async () => {
  //   console.log("QR Machine Connected");
  // };

  const checkPaymentStatus = async () => {
    const res = await getPaymentStatus(orderId);
    return res;
  };

  const openSettleConfirmation = ({ mode, amount, action = "settle" }) => {
    if (paymentActionLockRef.current || placeOrderApiLockRef.current) {
      return;
    }

    const finalAmount = Number(amount || 0);

    if (!Number.isFinite(finalAmount) || finalAmount <= 0) {
      toast.error("Please enter valid tendered amount");
      return;
    }

    setPendingSettlement({
      mode,
      amount: finalAmount,
      action,
    });

    setShowSettleConfirm(true);
  };

  const closeSettleConfirmation = () => {
    if (settlingAmount || placeOrderApiLockRef.current) {
      return;
    }

    // Confirmation cancel/back par saare temporary UI locks release karo.
    cashClickLockRef.current = false;
    paymentActionLockRef.current = false;

    setPaymentActionLoading(false);
    setShowSettleConfirm(false);
    setPendingSettlement(null);
    setSelectedMethod("");
  };

  const confirmSettlement = async () => {
    if (!pendingSettlement?.mode || !pendingSettlement?.amount) {
      toast.error("Settlement details missing");
      return;
    }

    if (
      settlingAmount ||
      paymentActionLockRef.current ||
      placeOrderApiLockRef.current
    ) {
      return;
    }

    const currentSettlement = {
      ...pendingSettlement,
    };

    if (currentSettlement.action === "open-other") {
      paymentActionLockRef.current = true;
      setPaymentActionLoading(true);
      setSelectedMethod("OTHER");

      setShowSettleConfirm(false);
      setPendingSettlement(null);
      setShowOtherPayment(true);

      return;
    }

    paymentActionLockRef.current = true;

    if (String(currentSettlement.mode || "").toUpperCase() === "CASH") {
      cashClickLockRef.current = true;
    }

    setPaymentActionLoading(true);
    setSettlingAmount(true);
    setSelectedMethod(currentSettlement.mode);

    try {
      const success = await handlePlaceOrder([
        {
          mode: currentSettlement.mode,
          amount: currentSettlement.amount,
        },
      ]);

      if (success) {
        setShowSettleConfirm(false);
        setPendingSettlement(null);
        return;
      }

      cashClickLockRef.current = false;
      paymentActionLockRef.current = false;
      placeOrderApiLockRef.current = false;

      setPaymentActionLoading(false);
      setSelectedMethod("");
    } catch (error) {
      console.error("Settlement confirmation error:", error);

      cashClickLockRef.current = false;
      paymentActionLockRef.current = false;
      placeOrderApiLockRef.current = false;

      setPaymentActionLoading(false);
      setSelectedMethod("");

      toast.error("Unable to settle the amount");
    } finally {
      setSettlingAmount(false);
    }
  };

  const handlePaymentAction = async (label, event) => {
    // BACK
    if (label === "BACK") {
      if (cashClickLockRef.current) return;

      handleBackClick();
      return;
    }

    // CANCEL
    if (label === "CANCEL") {
      if (cashClickLockRef.current) return;

      onClose?.();
      return;
    }

    // ASSIGN TO PACKKY
    if (label === "Assign To Packky") {
      if (
        cashClickLockRef.current ||
        paymentActionLockRef.current ||
        placeOrderApiLockRef.current
      ) {
        return;
      }

      setSelectedMethod("Assign To Packky");
      setShowPackkyModal(true);

      return;
    }

    // OTHER PAYMENT
    if (label === "OTHER") {
      if (cashClickLockRef.current) return;

      setSelectedMethod("OTHER");
      setShowOtherPayment(true);

      return;
    }

    // Only CASH should continue below
    if (label !== "CASH") {
      return;
    }

    console.count("CASH CLICK ATTEMPT");

    const clickedButton = event?.currentTarget;

    if (
      cashClickLockRef.current ||
      paymentActionLockRef.current ||
      placeOrderApiLockRef.current
    ) {
      console.warn("Payment already processing. Duplicate click blocked.");
      return;
    }

    const enteredAmount = Number(tendered || 0);

    if (!Number.isFinite(enteredAmount) || enteredAmount <= 0) {
      toast.error("Please enter valid settle amount");
      return;
    }

    const isPartialAmount = enteredAmount < Number(payableAmount);

    // IMPORTANT:
    // Partial payment me confirmation modal open hone se pehle payment lock
    // MAT lagao. Agar yahin paymentActionLockRef=true kar diya to
    // confirmSettlement() YES click par lock dekh ke return kar deta hai.
    if (isPartialAmount) {
      setSelectedMethod("CASH");

      setPendingSettlement({
        mode: "CASH",
        amount: enteredAmount,
        action: "settle",
      });

      setShowSettleConfirm(true);
      return;
    }

    // Full/exact payment me API call start hone se just pehle lock lagao.
    cashClickLockRef.current = true;
    paymentActionLockRef.current = true;

    setPaymentActionLoading(true);
    setSelectedMethod("CASH");

    if (clickedButton) {
      clickedButton.disabled = true;
    }

    try {
      console.log("Calling CASH place order only once");

      const success = await handlePlaceOrder([
        {
          mode: "CASH",
          amount: enteredAmount,
        },
      ]);

      console.log("CASH place order result:", success);

      if (!success) {
        cashClickLockRef.current = false;
        paymentActionLockRef.current = false;
        placeOrderApiLockRef.current = false;

        setPaymentActionLoading(false);
        setSelectedMethod("");

        if (clickedButton) {
          clickedButton.disabled = false;
        }

        toast.error(
          "Payment could not be completed. Please close and reopen the payment screen.",
        );
      }
    } catch (error) {
      cashClickLockRef.current = false;
      paymentActionLockRef.current = false;
      placeOrderApiLockRef.current = false;

      setPaymentActionLoading(false);
      setSelectedMethod("");

      if (clickedButton) {
        clickedButton.disabled = false;
      }

      console.error("Cash payment error:", error);
      toast.error(error?.message || "Cash payment failed");
    }
  };

  return (
    <>
      <div className="flex h-full w-full flex-col bg-white overflow-hidden montserrat-font-1">
        {/* ── MAIN CONTENT ── */}
        <div className="flex flex-1 overflow-hidden montserrat-font-1">
          {/* ══ LEFT: Order Summary ══ */}
          <div className="w-[42%] flex flex-col border-r border-gray-300 bg-white montserrat-font-1">
            <div className="px-6 py-4 border-b border-gray-200">
              <h2 className="text-lg font-semibold text-gray-800 text-center">
                Order Summary
              </h2>
            </div>

            {/* Table */}
            <div className="flex-1 overflow-y-auto montserrat-font-1">
              <table className="w-full text-sm">
                <thead className="bg-gray-50 border-b border-gray-200 montserrat-font-1">
                  <tr className="text-gray-600 font-medium">
                    <th className="px-4 py-3 text-center">Unit</th>
                    <th className="px-4 py-3 text-left">Item</th>
                    <th className="px-4 py-3 text-center">Unit Price</th>
                    <th className="px-4 py-3 text-right">Total Price</th>
                  </tr>
                </thead>
                <tbody>
                  {normalizedCart.map((item, i) => (
                    <tr key={i} className="border-b border-gray-100">
                      <td className="px-4 py-3 text-center text-gray-800">
                        {item.qty}
                      </td>
                      <td className="px-4 py-3 text-gray-800 font-bold text-[14px]">
                        <div>{item.item_name}</div>

                        {getCustomizationText(item) && (
                          <div className="text-[14px] text-gray-500 mt-1">
                            Custom: {getCustomizationText(item)}
                          </div>
                        )}
                      </td>
                      <td className="px-4 py-3 text-center text-gray-700">
                        ₹ {item.price}
                      </td>
                      <td className="px-4 py-3 text-right text-gray-700">
                        ₹ {(item.price * item.qty).toFixed(2)}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            {/* Summary rows */}
            <div className="border-t border-gray-200 px-6 py-4 space-y-2 text-sm montserrat-font-1">
              <div className="bg-gray-100 rounded-lg p-4 text-sm space-y-2">
                <div className="flex justify-between">
                  <span>Subtotal</span>
                  <span>₹ {subtotal.toFixed(2)}</span>
                </div>

                <div className="flex justify-between">
                  <span>Discount</span>
                  <span>- ₹ {discountAmount.toFixed(2)}</span>
                </div>

                <div className="flex justify-between">
                  <span>CGST {isInclusiveGst ? "(Included)" : ""}</span>
                  <span>₹ {cgstAmount.toFixed(2)}</span>
                </div>

                <div className="flex justify-between">
                  <span>SGST {isInclusiveGst ? "(Included)" : ""}</span>
                  <span>₹ {sgstAmount.toFixed(2)}</span>
                </div>

                <div className="flex justify-between">
                  <span>Delivery Charges</span>
                  <span>₹ {deliveryCharges.toFixed(2)}</span>
                </div>

                <div className="border-t pt-2 mt-2 flex justify-between font-bold text-base">
                  <span>
                    {hasLiveDiscount
                      ? "Total"
                      : apiDueAmount > 0
                        ? "Due Amount"
                        : "Total"}
                  </span>
                  <span>₹ {payableAmount}</span>
                </div>
              </div>
              {tenderedNum > payableAmount && (
                <div className="flex justify-between text-emerald-600 font-semibold">
                  <span>Change</span>
                  <span>₹ {change.toFixed(2)}</span>
                </div>
              )}
            </div>
            {payments.map((p, i) => (
              <div
                key={i}
                className="flex justify-between text-sm text-gray-700"
              >
                <span>{p.mode}</span>
                <span>₹ {p.amount}</span>
              </div>
            ))}
          </div>

          {/* ══ CENTER: Numpad ══ */}
          <div className="flex-1 flex flex-col px-6 py-4 bg-[#f8f8f8]">
            {/* Due Amount */}
            <div className="flex items-center justify-between mb-4">
              <span className="text-base font-medium text-gray-700">
                Due Amount
              </span>
              <span className="text-2xl font-bold text-gray-900">
                ₹ {payableAmount}
              </span>
            </div>

            {/* Tendered Amount */}
            <div className="flex items-center justify-between mb-5 border border-gray-300 rounded-lg px-4 py-2">
              <span className="text-sm text-gray-500 font-medium">
                Tendered Amount :
              </span>
              <input
                type="number"
                value={tendered}
                onFocus={() => {
                  if (
                    !tenderedTouched &&
                    Number(tendered) === Number(payableAmount)
                  ) {
                    setTendered("");
                  }
                }}
                onChange={(e) => {
                  setTenderedTouched(true);
                  setTendered(e.target.value);
                }}
                className="text-3xl font-bold text-gray-900 tracking-wide w-40 text-right outline-none bg-transparent"
                placeholder="0"
              />
            </div>

            {/* Numpad grid */}
            <div className="flex flex-col gap-2 flex-1">
              {numpadKeys.map((row, ri) => (
                <div key={ri} className="flex gap-2 flex-1">
                  {row.map((key) => (
                    <button
                      key={key}
                      onClick={() => handleNumpad(key)}
                      className={`flex-1 rounded-xl border text-base font-semibold transition-all active:scale-95 ${
                        key === "Clear"
                          ? "border-red-200 bg-red-50 text-red-500 hover:bg-red-100"
                          : "border-gray-200 bg-white text-gray-800 hover:bg-gray-50 hover:border-gray-300 shadow-sm"
                      }`}
                    >
                      {key}
                    </button>
                  ))}
                </div>
              ))}

              {/* EXACT + DISCOUNT */}
              <div className="flex gap-2" style={{ height: "56px" }}>
                <button
                  onClick={() => handleNumpad("EXACT")}
                  className="flex-1 rounded-xl border-2 border-gray-300 bg-white text-gray-800 font-bold text-sm hover:bg-gray-50 active:scale-95 transition-all"
                >
                  EXACT
                </button>
                <button
                  onClick={openDiscount}
                  className="flex-1 rounded-xl border-2 border-gray-300 bg-white text-gray-800 font-bold text-sm hover:bg-gray-50"
                >
                  DISCOUNT
                </button>
              </div>
            </div>
          </div>

          {/* ══ RIGHT: Payment methods ══ */}
          <div className="w-72 flex-shrink-0 border-l montserrat-font-1 border-gray-300 flex flex-col gap-7 p-5 bg-white">
            {[
              {
                label: "CASH",
                color: "bg-gray-100 hover:bg-gray-200 text-gray-800",
              },
              {
                label: "OTHER",
                color: "bg-gray-100 hover:bg-gray-200 text-gray-800",
              },

              ...(isHomeDeliveryOrder
                ? [
                    {
                      label: "Assign To Packky",
                      color: "bg-blue-100 hover:bg-blue-200 text-blue-800",
                    },
                  ]
                : []),

              {
                label: "BACK",
                color: "bg-gray-100 hover:bg-gray-200 text-gray-800",
              },
              {
                label: "CANCEL",
                color: "bg-gray-100 hover:bg-gray-200 text-gray-800",
              },
            ].map(({ label, color }) => {
              const isPaymentBusy =
                paymentActionLoading ||
                settlingAmount ||
                placeOrderApiLockRef.current ||
                showOrderPlaced;

              const isCurrentButtonLoading =
                paymentActionLoading && selectedMethod === label;

              return (
                <button
                  key={label}
                  type="button"
                  disabled={
                    cashClickLockRef.current ||
                    paymentActionLoading ||
                    settlingAmount ||
                    showOrderPlaced
                  }
                  onClick={(event) => handlePaymentAction(label, event)}
                  className={`h-[102px] rounded-md border font-bold text-[18px] shadow-sm transition-all ${
                    cashClickLockRef.current ||
                    paymentActionLoading ||
                    settlingAmount ||
                    showOrderPlaced
                      ? "cursor-not-allowed opacity-50"
                      : "active:scale-95"
                  } ${
                    selectedMethod === label
                      ? "border-emerald-400 bg-emerald-50 text-emerald-700"
                      : `border-gray-200 ${color}`
                  }`}
                >
                  {label === "CASH" && cashClickLockRef.current
                    ? "PROCESSING..."
                    : label}
                </button>
              );
            })}
          </div>
        </div>

        {/* ── BOTTOM BAR ── */}
        <div className="flex items-center montserrat-font-1 gap-3 px-4 py-3 border-t border-gray-300 bg-gray-50 flex-shrink-0">
          <button
            onClick={() => {
              if (isFullscreen) {
                exitFullscreen();
              } else {
                enterFullscreen();
              }
            }}
            className="bg-gray-700 hover:bg-gray-800 text-white text-xs font-semibold px-4 py-2 rounded-md transition-colors"
          >
            {isFullscreen ? "Exit Full Screen" : "Full Screen"}
          </button>

          <button
            onClick={() => {
              setTabletMode((prev) => {
                const newMode = !prev;
                setSelected?.(null);
                return newMode;
              });
            }}
            className="bg-white hover:bg-gray-100 text-gray-700 text-xs font-semibold px-4 py-2 rounded-md border border-gray-300 transition-colors"
          >
            {tabletMode ? "Exit Tablet Mode" : "On Tablet Mode"}
          </button>

          <button
            onClick={refreshCatalogueCache}
            disabled={loadingMenu}
            className="bg-white hover:bg-gray-100 text-gray-700 text-xs font-semibold px-4 py-2 rounded-md border border-gray-300 transition-colors flex items-center gap-1 disabled:opacity-60 disabled:cursor-not-allowed"
          >
            <span className="text-blue-500">⊞</span>
            {loadingMenu ? "Syncing..." : "Sync Menu"}
          </button>

          <button
            onClick={handleSyncTaxConfig}
            disabled={taxConfigLoading}
            className="bg-white hover:bg-gray-100 text-gray-700 text-xs font-semibold px-4 py-2 rounded-md border border-gray-300 transition-colors flex items-center gap-1 disabled:opacity-60 disabled:cursor-not-allowed"
          >
            <span className="text-yellow-500">⚠</span>
            {taxConfigLoading ? "Syncing..." : "Sync Tax Config"}
          </button>
        </div>

        <DiscountModal
          isOpen={showDiscountModal}
          onClose={() => setShowDiscountModal(false)}
          discounts={discountList}
          onApply={handleApplyDiscount}
          onRemove={handleRemoveDiscount}
          onPrint={processPrintOrder}
          orderId={activeOrderId || orderId}
          applyingDiscount={applyingDiscount}
          removingDiscount={removingDiscount}
        />

        <SelectPaymentModal
          isOpen={showOtherPayment}
          onClose={() => {
            setShowOtherPayment(false);

            if (!placeOrderApiLockRef.current) {
              paymentActionLockRef.current = false;
              setPaymentActionLoading(false);
              setSelectedMethod("");
            }
          }}
          cart={cart}
          orderId={activeOrderId || orderId}
          customerMobile={customerMobile}
          grandTotal={payableAmount}
          tenderedAmount={tenderedNum}
          orderType={normalizedOrderType}
          selectedTable={
            selectedTable || {
              tableNo: getTableNo(),
              roomNumber: isRoomOrder ? getTableNo() : "",
            }
          }
          selectedRoom={
            selectedRoom || {
              roomNumber: isRoomOrder ? getTableNo() : "",
            }
          }
          placePosOrder={callPlacePosOrderOnce}
          deliveryCharges={deliveryCharges}
          deliveryChargesDeductedFrom={deliveryChargesDeductedFrom}
          deliveryPartner={deliveryPartner}
          onConfirm={async (data) => {
            const receiptDetails = Array.isArray(data?.receiptData?.response)
              ? data.receiptData.response[0]
              : Array.isArray(data?.receiptData)
                ? data.receiptData[0]
                : data?.receiptData?.response || data?.receiptData || {};

            const mappedReceipt = {
              business_name:
                receiptDetails?.business_name ||
                receiptDetails?.businessName ||
                receiptDetails?.organization_name ||
                receiptDetails?.restaurant_name ||
                "Restaurant",

              address:
                receiptDetails?.address ||
                receiptDetails?.restaurant_address ||
                receiptDetails?.organization_address ||
                receiptDetails?.business_address ||
                receiptDetails?.shop_address ||
                receiptDetails?.full_address ||
                "",

              phone_no:
                receiptDetails?.phone_no ||
                receiptDetails?.phoneNo ||
                receiptDetails?.phone ||
                receiptDetails?.mobile ||
                receiptDetails?.mobile_no ||
                receiptDetails?.contact_number ||
                receiptDetails?.contact_no ||
                "",

              gst:
                receiptDetails?.gst ||
                receiptDetails?.gst_no ||
                receiptDetails?.gstNo ||
                receiptDetails?.gst_number ||
                "",

              fssaiNo:
                receiptDetails?.fssaiNo ||
                receiptDetails?.fssai_no ||
                receiptDetails?.fssai ||
                "",

              taxCgst:
                receiptDetails?.taxCgst ||
                receiptDetails?.tax_cgst ||
                receiptDetails?.cgstRate ||
                "0",

              taxSgst:
                receiptDetails?.taxSgst ||
                receiptDetails?.tax_sgst ||
                receiptDetails?.sgstRate ||
                "0",

              taxGst:
                receiptDetails?.taxGst ||
                receiptDetails?.tax_gst ||
                receiptDetails?.gstRate ||
                "0",

              tag_line1:
                receiptDetails?.tag_line1 ||
                receiptDetails?.tagLine1 ||
                "Visit Again",
            };

            setreciptDetails(mappedReceipt);

            const otherPaidAmount = Number(
              data?.paidAmount ?? data?.receivedAmount ?? tenderedNum ?? 0,
            );

            const remainingAfterOtherPayment = Number(
              Math.max(Number(payableAmount) - otherPaidAmount, 0).toFixed(2),
            );

            const otherUiPaymentStatus =
              remainingAfterOtherPayment > 0 ? "partially_paid" : "paid";

            setFinalPaidAmount(otherPaidAmount);

            setPrintData({
              ...(data?.orderData || {}),
              ui_paid_amount: otherPaidAmount,
              ui_due_amount: remainingAfterOtherPayment,
              ui_payment_status: otherUiPaymentStatus,
            });

            // SelectPaymentModal completes the API/print flow.
            // Refresh only here so table/room APIs run once.
            await refreshTableRoomStatus();

            setShowOtherPayment(false);
            setPaymentActionLoading(true);
            setSelectedMethod("OTHER");

            setTimeout(() => {
              setShowOrderPlaced(true);
            }, 100);
          }}
        />

        <CashPaymentModal
          isOpen={showOrderPlaced}
          cart={normalizedCart}
          total={payableAmount}
          paidAmount={finalPaidAmount}
          discount={discountAmount}
          delivery={deliveryCharges}
          orderType={normalizedOrderType}
          customerMobile={customerMobile}
          reciptDetails={finalReciptDetails}
          printData={printData}
          gstType={normalizedGstType}
          cgstRate={cgstRate}
          sgstRate={sgstRate}
          totalTaxRate={totalTaxRate}
          onClose={async (action) => {
            setShowOrderPlaced(false);

            cashClickLockRef.current = false;
            paymentActionLockRef.current = false;
            placeOrderApiLockRef.current = false;

            setPaymentActionLoading(false);
            setSettlingAmount(false);
            setSelectedMethod("");
            setPendingSettlement(null);
            setShowSettleConfirm(false);

            // Status was already refreshed once after successful placement.
            // Parent callback may refresh the orders list, so do not refresh
            // dining tables/rooms again here.
            await onAfterOrderSuccess?.();

            if (action === "home") {
              onClose("home");
            } else {
              onClose();
            }
          }}
        />

        <UpiPaymentModal
          isOpen={showUPI}
          onClose={() => {
            setShowUPI(false);

            if (!placeOrderApiLockRef.current) {
              paymentActionLockRef.current = false;
              setPaymentActionLoading(false);
              setSelectedMethod("");
            }
          }}
          onCheckPayment={checkPaymentStatus}
          cart={cart}
          orderId={activeOrderId || orderId}
          customerMobile={customerMobile}
          total={payableAmount}
          placePosOrder={callPlacePosOrderOnce}
          orderType={normalizedOrderType}
          selectedTable={
            selectedTable || {
              tableNo: getTableNo(),
              roomNumber: isRoomOrder ? getTableNo() : "",
            }
          }
          selectedRoom={
            selectedRoom || {
              roomNumber: isRoomOrder ? getTableNo() : "",
            }
          }
          deliveryCharges={deliveryCharges}
          deliveryChargesDeductedFrom={deliveryChargesDeductedFrom}
          deliveryPartner={deliveryPartner}
        />

        <AssignPackkyModal
          open={showPackkyModal}
          onClose={() => setShowPackkyModal(false)}
          subtotal={subtotal}
          discount={discountAmount}
          cgstRate={cgstRate}
          sgstRate={sgstRate}
          cgstAmount={cgstAmount}
          sgstAmount={sgstAmount}
          gstType={gstType}
          deliveryCharge={deliveryCharge}
          onDeliveryChargeChange={(charge) => {
            setDeliveryCharge(Number(charge || 0));
          }}
          onConfirm={(charge) => {
            const finalDeliveryCharge = Number(charge || 0);

            setDeliveryCharge(finalDeliveryCharge);

            const deductedFrom =
              finalDeliveryCharge > 0 ? "customer" : "restaurant";

            setDeliveryChargesDeductedFrom(deductedFrom);
            setDeliveryPartner("packky");

            setShowPackkyModal(false);

            toast.success("Delivery charge added. Now select payment method");
          }}
        />

        {/* discount model */}
        {showDiscountRemovedModal && (
          <div className="fixed inset-0 z-[80] flex items-center justify-center montserrat-font-1">
            <div className="w-[360px] rounded-2xl bg-white p-6 text-center shadow-2xl">
              <div className="mx-auto mb-3 flex h-14 w-14 items-center justify-center rounded-full bg-emerald-100 text-2xl text-emerald-600">
                ✓
              </div>

              <h2 className="text-xl font-bold text-gray-900">
                Your discount is removed
              </h2>

              <p className="mt-2 text-sm text-gray-500">Going back...</p>
            </div>
          </div>
        )}

        {/* settle confirm model */}
        {showSettleConfirm && (
          <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/50 px-4 montserrat-font-1">
            <div className="w-full max-w-[420px] overflow-hidden rounded-2xl bg-white shadow-2xl">
              {/* Header */}
              <div className="border-b border-gray-200 px-6 py-5 text-center">
                <div className="mx-auto mb-3 flex h-14 w-14 items-center justify-center rounded-full bg-amber-100 text-2xl">
                  ₹
                </div>

                <h2 className="text-xl font-bold text-gray-900">
                  {pendingSettlement?.action === "open-other"
                    ? "Confirm Other Payment"
                    : "Confirm Settlement"}
                </h2>

                <p className="mt-2 text-sm text-gray-500">
                  {pendingSettlement?.action === "open-other"
                    ? "Are you sure you want to continue with other payment?"
                    : "Are you sure you want to settle this amount?"}
                </p>
              </div>

              {/* Amount */}
              <div className="px-6 py-6">
                <div className="rounded-xl border border-emerald-200 bg-emerald-50 px-5 py-4 text-center">
                  <p className="text-xs font-semibold uppercase tracking-wider text-emerald-700">
                    Tendered Amount
                  </p>

                  <p className="mt-1 text-3xl font-extrabold text-emerald-700">
                    ₹
                    {Number(pendingSettlement?.amount || 0).toLocaleString(
                      "en-IN",
                      {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      },
                    )}
                  </p>

                  <p className="mt-1 text-xs font-semibold uppercase text-gray-500">
                    Payment Mode: {pendingSettlement?.mode || "CASH"}
                  </p>
                </div>
              </div>

              {/* Actions */}
              <div className="grid grid-cols-2 gap-3 border-t border-gray-200 bg-gray-50 px-6 py-4">
                <button
                  type="button"
                  onClick={closeSettleConfirmation}
                  disabled={settlingAmount}
                  className="rounded-xl border border-gray-300 bg-white px-4 py-3 font-bold text-gray-700 transition hover:bg-gray-100 disabled:cursor-not-allowed disabled:opacity-60"
                >
                  NO, GO BACK
                </button>

                <button
                  type="button"
                  onClick={confirmSettlement}
                  disabled={settlingAmount}
                  className="rounded-xl bg-emerald-500 px-4 py-3 font-bold text-white transition hover:bg-emerald-600 disabled:cursor-not-allowed disabled:opacity-60"
                >
                  {settlingAmount
                    ? "SETTLING..."
                    : pendingSettlement?.action === "open-other"
                      ? "YES, CONTINUE"
                      : "YES, SETTLE"}
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
}
